import { Injectable, inject } from '@angular/core';
import { LernformKey } from '../../../../model/aggregations';
import { orderedKombiLernformen } from '../../../../model/lernformen';
import { LernformFacettenService } from './lernformfacetten.service';
import { LernformUrlService } from './lernformurl.service';

@Injectable({ providedIn: 'root' })
export class KombiLernformService extends LernformFacettenService {
  static identifier: LernformKey = LernformKey.Kombi;

  constructor() {
    const lernformUrlService = inject(LernformUrlService);

    super(lernformUrlService, KombiLernformService.identifier, orderedKombiLernformen);
  }
}
